<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  percent: {
    type: Number,
    default: 0,
  },
});

const getPercent = (amount, target) => {
  if (!target) return 0;
  return Math.round((amount / target) * 100);
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">สรุปการจัดเก็บรายเดือน</h5>
          <div class="text-muted small">เปรียบเทียบยอดจัดเก็บกับเป้าหมาย</div>
        </div>
        <div class="badge rounded-pill text-bg-primary px-3 py-2">
          {{ percent }}%
        </div>
      </div>

      <div class="vstack gap-3">
        <div v-for="item in items" :key="item.month">
          <div class="d-flex justify-content-between small mb-1">
            <span class="fw-semibold">{{ item.month }}</span>
            <span class="text-muted">
              {{ formatCurrency(item.amount) }} /
              {{ formatCurrency(item.target) }}
            </span>
          </div>
          <div class="progress rounded-pill" style="height: 10px">
            <div
              class="progress-bar"
              role="progressbar"
              :style="{ width: `${getPercent(item.amount, item.target)}%` }"
              :aria-valuenow="getPercent(item.amount, item.target)"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
